import { getAttr, getEntityId } from '../../../../features/helpers/apiHelpers';

export const mapKleHierarchyItems = (kleHierarchyItem) => {
  return {
    key: getEntityId(kleHierarchyItem),
    name: `${getAttr(kleHierarchyItem, 'number')} ${getAttr(
      kleHierarchyItem,
      'name',
    )}`,
    number: getAttr(kleHierarchyItem, 'number'),
  };
};
